import React, { useState, useEffect } from 'react';
import {useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import Results from './Results';
import Toolbar from './Toolbar';
import data from './data';
import Firebase from 'src/Firebase.js'
import UserQuoteTable from './UserQuoteTable';
import UserTableWrapper from './UserTableWrapper';
import ShipperTableWrapper from './ShipperTableWrapper';
import TransportersTableWrapper from './TransportersTableWrapper';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));


const CustomerListView = (props) => {
  const classes = useStyles();
  const [customers] = useState(data);
  const navigate = useNavigate();
  useEffect(() => {
    // Update the document title using the browser API

    
  });

  function navigaterFunc(path, props) {
    //alert('attempt navigate')
    navigate(path, props)
  }

  return (
    <Page
      className={classes.root}
      title="Jobs"
    >
      <Container maxWidth={false}>
        <Toolbar />
        <Box mt={3}>
         <div id='fk11'>
          <UserTableWrapper navigater={(a,b) => navigaterFunc(a,b)} customers={customers}/>
          </div>


        </Box>
      </Container>
    </Page>
  );
};

export default CustomerListView;
